import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { singleOrganization } from '../mockData/organizations-data';
import { selfRegistrationMsg, vitalsData } from '../mockData/self-registration-data';

const SelfRegistrationApi = [
  rest.get(`${API_ROOT}self-enrollment`, (req, res, ctx) => {
    const accessCode = req.url.searchParams.get('accessCode');
    if (accessCode === singleOrganization.accessCode) {
      return res(ctx.json({ isAccessCodeVerified: true }));
    }
    return res(ctx.json({}));
  }),
  rest.post(`${API_ROOT}self-enrollment`, (req, res, ctx) => res(ctx.json(selfRegistrationMsg))),
  rest.put(`${API_ROOT}self-enrollment`, (req, res, ctx) => res(ctx.json(vitalsData))),
];

export default SelfRegistrationApi;
